import AuthorList from "./author-list.page";

export default AuthorList;
